
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsSms = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 28,
  viewBox: "0 0 20 28"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.987 7.73v5.834c0 1.186.962 2.18 2.18 2.18h.64v2.18c0 .255.129.448.353.544.064.032.16.064.225.064.16 0 .288-.064.416-.16l2.725-2.628h5.16c1.186 0 2.18-.962 2.18-2.18V7.731c0-1.186-.962-2.18-2.18-2.18H8.135c-1.154.032-2.148.994-2.148 2.18zm12.725 0v5.834c0 .545-.45.962-.962.962h-5.417a.674.674 0 0 0-.416.16l-1.891 1.827v-1.378a.61.61 0 0 0-.61-.61H8.2a.964.964 0 0 1-.962-.96V7.73c0-.545.449-.962.962-.962h9.551c.513 0 .962.449.962.962zM.256 24.95V3.019A1.93 1.93 0 0 1 2.18 1.096h11.635c1.058 0 1.923.866 1.923 1.923v1.026a.609.609 0 1 1-1.218-.001V3.02a.711.711 0 0 0-.705-.705H2.18a.711.711 0 0 0-.705.705v21.93c0 .384.32.705.705.705h11.635a.71.71 0 0 0 .705-.705v-7.635a.61.61 0 0 1 1.218.001v7.634a1.929 1.929 0 0 1-1.923 1.923H2.18A1.93 1.93 0 0 1 .257 24.95zm9.808-1.635a.61.61 0 0 1-.609.61h-2.98a.61.61 0 1 1 0-1.219h2.98a.59.59 0 0 1 .61.61z",
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 0.4
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"28\" viewBox=\"0 0 20 28\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\".4\">\r\n            <g>\r\n                <g>\r\n                    <path d=\"M5.987 6.73v5.834c0 1.186.962 2.18 2.18 2.18h.64v2.18c0 .255.129.448.353.544.064.032.16.064.225.064.16 0 .288-.064.416-.16l2.725-2.628h5.16c1.186 0 2.18-.962 2.18-2.18V6.731c0-1.186-.962-2.18-2.18-2.18H8.135c-1.154.032-2.148.994-2.148 2.18zm12.725 0v5.834c0 .545-.45.962-.962.962h-5.417c-.16 0-.288.064-.416.16l-1.891 1.827v-1.378c0-.32-.257-.61-.61-.61H8.2c-.545 0-.962-.448-.962-.96V6.73c0-.545.449-.962.962-.962h9.551c.513 0 .962.449.962.962zM.256 23.95V2.019C.256.962 1.122.096 2.18.096h11.635c1.058 0 1.923.866 1.923 1.923v1.026c0 .32-.256.609-.609.609-.32 0-.609-.257-.609-.61V2.02c0-.384-.32-.705-.705-.705H2.18c-.384 0-.705.32-.705.705v21.93c0 .384.32.705.705.705h11.635c.385 0 .705-.32.705-.705v-7.635c0-.32.257-.609.61-.609.32 0 .608.257.608.61v7.634c0 1.057-.865 1.923-1.923 1.923H2.18c-1.057 0-1.923-.866-1.923-1.923zm9.808-1.635c0 .32-.256.61-.609.61h-2.98c-.321 0-.61-.257-.61-.61 0-.32.257-.609.61-.609h2.98c.353 0 .61.257.61.61z\" transform=\"translate(-322 -471) translate(45 465) translate(277 6) translate(0 1)\"/>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-sms.cde4cc54fcd1b19174e7b2ed2a666dd2.svg"),
        {
          React: SvgIconsSms,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      